<template>
  <div class="memberIndex">
    <div class="right">
      <div class="currentMenu">供应商谈判/单一来源> 谈判邀请函接收</div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">谈判邀请函接收</div>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span>项目名称</span>
            <el-input type="text" class="input" v-model="Query.ProjectName" size="mini"></el-input>
            <span>招标方式</span>
            <el-select class="input" v-model="Query.PurchaseMethod" placeholder="请选择">
              <el-option v-for="item in PurchaseMethods" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
            </el-select>
            <span>项目类型</span>
            <el-select class="input" v-model="Query.ProjectType" placeholder="请选择">
              <el-option v-for="item in ProjectTypes" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
            </el-select>
            <el-button id="search" @click="fnGetData">搜索</el-button>
          </div>
          <el-table class="table_wrap1" :data="InvitationList.slice((currentPage - 1) * PageSize, currentPage * PageSize)" style="width: 100%" :height="height" :default-expand-all="true">
            <el-table-column type="expand" style="padding: 0">
              <template slot-scope="props">
                <table class="statistics_table">
                  <tr>
                    <th class="th1">
                      <el-checkbox @change="ChangeCbxAll($event, props.row)"></el-checkbox>
                    </th>
                    <th class="th1">包组信息</th>
                    <th class="th1">状态</th>
                    <th class="th1">谈判确认截止时间</th>
                  </tr>
                  <tr v-for="(item, index) in props.row.schemeList" :key="index">
                    <td class="td1">
                      <el-checkbox v-if="item.CanOperate" v-model="item.IsCheck"></el-checkbox>
                    </td>
                    <td class="td1">{{ item.ProjectName }}-{{ item.GroupName }}</td>
                    <td class="td1">
                      <div v-if="item.Stutas == '未回复'" class="tag-danger">
                        <span>{{ item.Status }}</span>
                      </div>
                      <div v-if="item.Stutas != '未回复'" class="tag-success">
                        <span>{{ item.Status }}</span>
                      </div>
                    </td>
                    <td class="td1">{{ item.TenderConfirmDate }}</td>
                  </tr>
                </table>
              </template>
            </el-table-column>

            <el-table-column prop="SchemeCode" label="采购编号"></el-table-column>
            <el-table-column prop="ProjectName" label="项目名称">
              <template slot-scope="scope">
                <el-link @click="Detail(scope.row, scope.row.ProjectName)" :underline="false" style="color: #0361b1; padding-right: 10px">{{ scope.row.ProjectName }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="SchemeCount" label="包组数量"></el-table-column>
            <el-table-column prop="PurchaseMethod" label="采购方式"></el-table-column>
            <el-table-column prop="ProjectType" label="项目类型"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="btn_wrap">
                  <el-button class="btn" @click="fnUpload(scope.row, scope.row.ProjectName)" type="text" v-if="scope.row.CanOperate" size="small">接收/拒绝邀请</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      Query: {},
      InvitationList: [],
      PurchaseMethods: [],
      ProjectTypes: [],
      ownPurchaseMethod: [4, 5],
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      // 个数选择器（可修改）
      pageSizes: [10, 25, 50, 100],
      // 默认每页显示的条数（可修改）
      PageSize: 25,
      height: window.innerHeight - 268
    }
  },
  created() {},
  computed: {},
  mounted() {
    this.AddListener()
    this.fnInit()
    this.fnGetData()
  },
  methods: {
    Detail(row, ProjectName) {
      var autoIdArr = row.schemeList.map((item, key) => {
        return item.AutoId
      })
      let routerData = this.$router.resolve({
        name: 'InvitationRecieptDetail',
        query: {
          id: autoIdArr.join(','),
          ProjectName: ProjectName
        }
      })
      window.open(routerData.href, '_blank')
    },
    AddListener() {
      //监听（刷新列表）
      window.addEventListener('storage', (e) => {
        if (e.key == 'InvitationList') {
          this.fnGetData()
        }
      })
    },
    fnGetData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query),
          PurchaseMethod: JSON.stringify(this.ownPurchaseMethod)
        }
      }
      this.getRequest('Purchase/GetInvitationList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.InvitationList = res.data.InvitationList
            this.totalCount = this.InvitationList.length
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnUpload(row, ProjectName) {
      var autoIdArr = row.schemeList.map((item, key) => {
        if (item.IsCheck) {
          return item.AutoId
        }
      })
      if (autoIdArr.filter((x) => x != undefined).length == 0) {
        this.$message.warning('请先选择包组')
        return
      }
      let routerData = this.$router.resolve({
        name: 'InvitationReciept',
        query: {
          id: autoIdArr.join(','),
          ProjectName: ProjectName
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnInit() {
      //获取登录供应商基础信息
      this.getRequest('SupplierLogin/MemberCenterData')
        .then((res) => {
          if (res.data.errcode == 0) {
            this.loginInfos = res.data.logindata
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      //获取下拉列表

      let config = {
        params: {
          PurchaseMethod: JSON.stringify(this.ownPurchaseMethod)
        }
      }
      this.getRequest('Purchase/GetInvitationQueryList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.PurchaseMethods = res.data.PurchaseMethods
            this.ProjectTypes = res.data.ProjectTypes
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    ChangeCbxAll(obj, item) {
      if (
        this.InvitationList.filter((x) => {
          return x.SchemeGroupId == item.SchemeGroupId
        }).length > 0
      ) {
        this.InvitationList.forEach((x) => {
          if (x.SchemeGroupId == item.SchemeGroupId) {
            x.schemeList.forEach((s) => {
              s.IsCheck = obj
            })
          }
        })
      }
    },
    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val
    }
  }
}
</script>
<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    width: 100%;
    background: #e4e4e4;
    // flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      // height: 93%;
      background: #f7f7f7;
      padding-bottom: 10px;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}

.statistics_table {
  width: 100%;
  // margin: 5px auto;

  th,
  td {
    text-align: center;
  }

  th {
    background-color: rgba(243, 251, 255, 1);
    color: #0179bd;
    font-weight: 700;
  }
  .tag-success {
    background-color: rgba(240, 249, 236, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(225, 243, 216, 1);
    border-radius: 5px;
    display: inline-block;
    line-height: 30px;
    span {
      padding: 0 12px;
      font-family: 'Arial Normal', 'Arial';
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: #67c23a;
      text-align: center;
    }
  }

  .tag-danger {
    background-color: rgba(254, 241, 241, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(253, 226, 226, 1);
    border-radius: 5px;
    display: inline-block;
    line-height: 30px;
    span {
      padding: 0 12px;
      font-family: 'PingFang SC Regular', 'PingFang SC';
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: #f56c6c;
      text-align: center;
    }
  }
}
</style>